export default "__VITE_ASSET__YSySQHtX__"